import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLeague } from "../../hooks/useLeague";
import SeasonSetupWizard from "./SeasonSetupWizard";

function SeasonSetupPage() {
  const { currentLeague, isLoading } = useLeague();
  const navigate = useNavigate();

  useEffect(() => {
    // If no league exists after loading, redirect to league setup
    if (!isLoading && !currentLeague) {
      navigate("/setup/league", { replace: true });
    }
  }, [currentLeague, isLoading, navigate]);

  if (isLoading) {
    return <div className="text-center">Loading...</div>;
  }

  return (
    <div>
      <h2 className="mb-4 text-center">Create Your First Season</h2>
      <SeasonSetupWizard />
    </div>
  );
}

export default SeasonSetupPage;
